"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = __importDefault(require("lodash/compact"));
const defaultKey = ['activity-obj'];
const keys = {
    default: defaultKey,
    activityObjId: (id) => (0, compact_1.default)([...defaultKey, id]),
    activityObj: (id, params) => {
        return (0, compact_1.default)([...defaultKey, id, params]);
    }
};
exports.default = keys;
